import PaginationSdk from '../components/Pagination/corvid/Pagination.corvid';


const Pagination = {
  sdk: PaginationSdk
};


export const components = {
  ['Pagination']: Pagination
};

